export enum IcalChannel {
  Hopper = 'hopper.com',
  HipCamp = 'hipcamp.com',
  Houfy = 'houfy.com',
  Lodgify = 'lodgify.com',
  OwnerRez = 'ownerrez.com',
  MisterBnB = 'misterbandb.com',
  Hostfully = 'hostfully.com',
  FurnishedFinder = 'furnishedfinder.com',
  Expedia = 'expedia.com',
  Tripadvisor = 'tripadvisor.com',
}

export enum Channel {
  Airbnb = 'airbnb',
  AirbnbOfficial = 'airbnb-official',
  Booking = 'booking',
  Vrbo = 'homeaway',
  VrboOfficial = 'vrbo-official',
  Agoda = 'agoda',
  Manual = 'manual',
  Direct = 'direct',
  Gvr = 'gvr',
}

export const CHANNEL_BACKGROUND_COLORS: Record<Channel, string> = {
  [Channel.Airbnb]: 'bg-ota-airbnb',
  [Channel.AirbnbOfficial]: 'bg-ota-airbnb',
  [Channel.Vrbo]: 'bg-ota-homeaway',
  [Channel.VrboOfficial]: 'bg-ota-homeaway',
  [Channel.Booking]: 'bg-ota-booking',
  [Channel.Agoda]: 'bg-ota-agoda',
  [Channel.Direct]: 'bg-ota-direct',
  [Channel.Gvr]: 'bg-ota-direct',
  [Channel.Manual]: 'bg-ota-manual',
};

export const CHANNEL_TEXT_COLORS: Record<Channel, string> = {
  [Channel.Airbnb]: 'text-ota-airbnb',
  [Channel.AirbnbOfficial]: 'text-ota-airbnb',
  [Channel.Vrbo]: 'text-ota-homeaway',
  [Channel.VrboOfficial]: 'text-ota-homeaway',
  [Channel.Booking]: 'text-ota-booking',
  [Channel.Agoda]: 'text-ota-agoda',
  [Channel.Direct]: 'text-ota-direct',
  [Channel.Gvr]: 'text-ota-direct',
  [Channel.Manual]: 'text-ota-manual',
};
